export class RegistroSlider{
    title: string;
    foto: Date;
    id:string;
    categoria:string;
    fotoMovil:string;
    link:string;
    button:string;
    state:string;
}